import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../axiosBaseQuery';

export interface DetailsResponseResult {
  Data: DetailsResponse;
  IsFailure: boolean;
  IsSuccess: boolean;
}

export interface DetailsResponse {
  Email: string;
  FirstName: string;
  IsFullyRegistered: boolean;
  HasChildWhoRequireMigration: boolean;
  LastName: string;
}

export interface UserDetails {
  email: string;
  firstName: string;
  isFullyRegistered: boolean;
  lastName: string;
  hasChildWhoRequireMigration: boolean;
  hideNotificationAboutAvailableMigration: boolean;
  hideShowInboxNotificationBar: boolean;
  hideShowPrsNotificationBar: boolean;
}

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/web-api/b2c/api',
  }),
  endpoints: (builder) => ({
    getDetails: builder.query<UserDetails, void>({
      query: () => ({ url: '/security/user/details', method: 'get' }),
      transformResponse: (res: DetailsResponseResult) => ({
        email: res.Data.Email,
        firstName: res.Data.FirstName,
        isFullyRegistered: res.Data.IsFullyRegistered,
        lastName: res.Data.LastName,
        hasChildWhoRequireMigration: res.Data.HasChildWhoRequireMigration,
        hideNotificationAboutAvailableMigration: false,
        hideShowInboxNotificationBar: false,
        hideShowPrsNotificationBar: false
      }),
    }),
    changePassword: builder.mutation<void, { newPassword: string; currentPassword: string }>({
      query: (data) => ({ url: '/security/changePassword', method: 'post', data }),
    }),
  }),
});

export const { useLazyGetDetailsQuery, useGetDetailsQuery, useChangePasswordMutation, endpoints } = userApi;
